module.exports = __webpack_public_path__ + "img/logo_Omni_Banco_Financeira_RGB-02.9945a878.png";